import React, { Component } from 'react';
import styles from './styles/index.scss';

import CloseIcon from '@material-ui/icons/Close';
import MaxViewIcon from '@material-ui/icons/ZoomOutMap';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';

import { string, bool, func } from 'prop-types';

export default class GlobalDocumentation extends Component {
  static propTypes = {
    source: string,
    open: bool,
    onClose: func
  };

  showAllDocumentation = () => {
    const { source } = this.props;
    let location = source;
    if (__DEV__) return window.open(location); // don't get contentWindow in Dev env
    try {
      location = this.iframeRef.contentWindow.location.href; // get current location of iframe in case same origin
    } catch (err) {
      // ignore
    }
    window.open(location);
  };

  iframeDocumentationRef = node => {
    this.iframeRef = node;
  };

  render() {
    const { source, open, onClose } = this.props;
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        className={styles['drawer']}
        variant="persistent"
        data-veritone-element={`documentation-link-${source}`}
      >
        <div className={styles['container-iframe']}>
          <Toolbar className={styles['toolbar']}>
            <IconButton onClick={this.showAllDocumentation}>
              <MaxViewIcon className={styles['icon-toolbar']} />
            </IconButton>
            <IconButton className={styles['icon-close']} onClick={onClose}>
              <CloseIcon className={styles['icon-toolbar']} />
            </IconButton>
          </Toolbar>
          <iframe
            src={source}
            className={styles['iframe-content']}
            ref={this.iframeDocumentationRef}
          />
        </div>
      </Drawer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/GlobalDocumentation/index.js